const GTM_EVENT = {
  HOTJAR: 'ga_database_received_profile_info_successful',
}

export default ({ store, $gtm, route }) => {
  let isLoadedUserInfo = false
  let isLoadedLimits = false
  let isHotjarHasBeenSent = false
  
  const trySendGtn = () => {
    // const layoutName = route?.matched && route?.matched[0] && route?.matched[0]?.components?.default?.options?.layout
    // const isMainLayout = layoutName === 'main'
    if (
      isHotjarHasBeenSent
      || !isLoadedUserInfo
      || !isLoadedLimits
    ) return

    const user = store.getters['user/user']
    isHotjarHasBeenSent = true
    $gtm.push({
      event: GTM_EVENT.HOTJAR,
      isUserDocumentsVerified: store.getters['user/isUserDocumentsVerified'] ? 1 : 0,
      isContactsVerified: (user.is_email_verified || user.is_phone_verified) ? 1 : 0,
      isLimitsHasBeenSet: store.getters['limits/get_isLimitsHasBeenSet'] ? 1 : 0,
      userId: user.id,
      payInCount: user.payin_count,
      registrationDate: user.created_date,
    })
  }
  store.watch(
    () => store.getters['user/user'].session_id,
    () => {
      if (isHotjarHasBeenSent) return
      isLoadedUserInfo = true
      trySendGtn()
    }
  )
  store.watch(
    () => store.getters['limits/get_limitsIsLoaded'],
    () => {
      if (isHotjarHasBeenSent) return
      isLoadedLimits = true
      trySendGtn()
    }
  )
  store.watch(
    () => store.getters['user/isLoggedIn'],
    () => {
      if (!store.getters['user/isLoggedIn']) {
        isLoadedLimits = false
        isLoadedUserInfo = false
        isHotjarHasBeenSent = false
      }
    }
  )
}
